angular.module('salesPath2')
  .controller('resourceTooltipModalCtrl', ['$scope', 'resourceTooltipModalHelper',
    function($scope, resourceTooltipModalHelper) {

      $scope.modalData = resourceTooltipModalHelper.tooltipModal.data;

    }
  ]);